import { styled } from 'styles/stitches.config'
import { rem } from 'polished'
import { Avatar as AvatarChakra } from "@chakra-ui/react";


export const Author = styled('div', {
  my: 50,

  '@sm': {
    display: 'flex',
    alignItems: 'center',
  },
})

export const Right = styled('div', {

  '@sm': {
    marginLeft: 20,
  },
})

export const Thumbnail = styled(AvatarChakra, {
  overflow: 'hidden',
  marginBottom: 10,

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  '@lg': {
    marginBottom: 0,
  },
})

export const Name = styled('p', {
  marginBottom: 10,

  fontFamily: '$domine',
  fontSize: rem(20),
  color: '$grey900'
})

export const Description = styled('p', {
  fontFamily: '$raleway',
  fontSize: rem(13),
  color: '$grey600',
})
